import React, { useEffect, useState } from "react";
import Box from "components/common/Box";

/**
 * Product card image. If a remote `/dashboard/icon-images` URL fails,
 * fall back to the local icon from productRouteMap.
 */
const ProductCardIcon = ({ product, sx }) => {
  const icon = product?.icon;
  const localIcon = product?.localIcon;
  const [src, setSrc] = useState(icon);

  useEffect(() => {
    setSrc(icon);
  }, [icon]);

  if (!src) return null;

  return (
    <Box
      component="img"
      src={src}
      alt=""
      onError={() => {
        if (localIcon && src !== localIcon) {
          setSrc(localIcon);
        }
      }}
      sx={sx}
    />
  );
};

export default ProductCardIcon;
